<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>
@for (list of lists; track list) {
  <div id="questionLists" class="col-md-10 mt-5">
    <h2 class="pb-3">{{ list.title }}</h2>
    <p >
      <a href="{{ list.url1 }}" target="_blank">{{ list.pdf1 }}</a>
      <br />
      <a href="{{ list.url2 }}" target="_blank">{{ list.pdf2 }}</a>
      <br />
      <a href="{{ list.url3 }}" target="_blank">{{ list.pdf3 }}</a>
      <br />
      <a href="{{ list.url4 }}" target="_blank">{{ list.pdf4 }}</a>
      <br />
      <a href="{{ list.url5 }}" target="_blank">{{ list.pdf5 }}</a>
    </p>
  </div>
}
